(ns assemble.assets-page.drawer.fonts
  (:require ["@mui/material/Box$default" :as Box]
            ["@mui/material/Divider$default" :as Divider]
            ["@mui/material/Grid$default" :as Grid]
            ["@mui/material/Icon$default" :as Icon]
            ["@mui/material/IconButton$default" :as IconButton]
            ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            [assemble.component.drawer.hooks :as dh]
            [assemble.component.drawer.view :refer [drawer]]
            [assemble.util :as util]
            [common.resource.query.user :as uq]
            [common.util :refer [format-iso-string]]
            [common.widgets.form-field :refer [form-field]]
            [re-frame.core :as rf]
            [uix.core :refer [$ defui]]))

(defui preview-container [{:keys [children]}]
  ($ Grid
     {:container true
      :sx #js {:height "200px"
               ;; This was #7A7A7A in the Figma
               :bgcolor "grey.50"
               ;; #D3D3D3 in Figma
               :color "grey.40"
               :borderRadius "4px"
               :fontWeight "600"
               :alignContent "center"
               :justifyContent "center"}}
     children))

(defui font-preview [{:asset/keys [key-url metadata]}]
  (let [{:keys [font-family font-weight font-style]} metadata]
    ($ Grid
       {:sx #js {:height "200px"
                 :backgroundColor "grey.90"
                 :overflow "hidden"
                 :p 2
                 :display "flex"
                 :alignItems "center"}}
       ;; Refer directly to asset file from CSS
       ($ :style
          (str "@font-face {\n"
               "  font-family: \"preview-" font-family "\";\n"
               "  font-weight: " font-weight ";\n"
               (when font-style
                 (str "  font-style: " font-style ";\n"))
               "  font-display: block;\n"
               "  src: url(\"" key-url "\")"
               "}"))
       ($ :p
          {:style {:font-size "32px"
                   :font-family (str "preview-" font-family)
                   :font-weight font-weight
                   :font-style (when (seq font-style)
                                 font-style)}}
          "The quick brown fox jumps over the lazy dog"))))

(defui preview-view [{:asset/keys [name] :as asset}]
  (let [{:keys [use-preview icon]} (util/get-file-type-parameters name)
        preview (case use-preview
                  :font ($ font-preview asset)
                  nil)]
    ($ Grid
       {:container true
        :justifyContent "center"
        :size #js {:xs 12}}
       (if preview
         preview
         ($ preview-container
            (if icon
              ($ Icon
                 {:sx #js {:fontSize "8rem"}}
                 icon)
              "No preview available"))))))

(defui font-css-snippet [{:asset/keys [font-css-url]}]
  (let [css-snippet (str "<link ref=\"stylesheet\" type=\"text/css\" media=\"all\" href=\"" font-css-url "\">")]
    ($ Stack
       {:spacing 1
        :sx #js {:flex 1}}
       ($ Typography
          {:component "p"}
          "Copy the below to your template <head>")
       ($ Box
          {:sx #js {:backgroundColor "grey.70"
                    :p 1
                    :position "relative"
                    :overflow "auto"}}
          ($ Typography
             {:component "pre"
              :sx #js {:whiteSpace "pre-wrap"
                       :textOverflow "hidden"
                       :wordBreak "break-all"}}
             ($ :code
                css-snippet
                ;; Placeholder to reserve space for the copy icon.
                ($ :span
                   {:style #js {:display "inline-block"
                                :width "28px"}}
                   " ")))
          ($ IconButton
             {:onClick (fn [_e] (rf/dispatch [:assemble.assets-page/copy-to-clipboard css-snippet]))
              :color "primary"
              :sx #js {:position "absolute"
                       :bottom 0
                       :right 0}}
             ($ Icon "content_copy"))))))

(defui font-details [{:asset/keys [metadata created-by created-at] :as data}]
  (let [username (uq/use-user-id->user-name created-by)

        {:keys [font-family font-style font-weight]} metadata]
    ($ :<>
       ($ form-field
          {:label "Family"}
          font-family)

       ($ form-field
          {:label "Weight"}
          (util/format-font-weight font-weight))

       ($ form-field
          {:label "Style"}
          (util/format-font-style font-style))

       ($ form-field
          {:label "Source"}
          ($ font-css-snippet data))

       ($ Divider)

       ($ form-field
          {:label "Owner"}
          username)

       ($ form-field
          {:label "Created"}
          (format-iso-string created-at "LL")))))

(defui fonts-drawer []
  (let [data (dh/use-drawer-assets-data)
        open? (dh/use-drawer-open? :file)
        on-close #(rf/dispatch [:assemble.assets-page/drawer-close])]
    ($ drawer
       {:name (:asset/name data)
        :detail-view ($ font-details data)
        :preview-view ($ preview-view data)
        :allow-rename? false
        :data data
        :open? open?
        :on-close on-close
        :show-archive? false
        :show-move? false})))

(defui font-family-details [data]
  (let [{:font-family/keys [display-name created-by created-on]} data
        username (uq/use-user-id->user-name created-by)]
    ($ :<>
       ($ form-field
          {:label "Font family name"}
          display-name)

       ($ Divider)

       (when username
         ($ form-field
            {:label "Owner"}
            username))

       (when created-on
         ($ form-field
            {:label "Created"}
            (format-iso-string created-on "LL"))))))

(defui font-family-drawer [{:keys [font-family]}]
  (let [{:font-family/keys [id] :as data} (dh/use-drawer-font-family-data)
        open? (dh/use-drawer-open? :font-family)
        on-close #(rf/dispatch [:assemble.assets-page/fonts-drawer-close])]
    ($ drawer
       {:name font-family
        :detail-view ($ font-family-details data)
        :open? open?
        :on-close on-close
        :on-rename (fn [new-value]
                     (js/Promise. (fn [resolve reject]
                                    (rf/dispatch [:assemble.resource.asset/update-font-family-name resolve reject
                                                  (cond-> {:font-family/display-name new-value
                                                           :font-family/original-name font-family}
                                                    (not (nil? id)) (assoc :font-family/id id))]))))
        :show-archive? false
        :show-move? false
        :show-tabs? false})))
